<pbc-sorter [config]="FotoKategorienSorterConfig" [sorter]="fotoKategorien.sorter$ | async" (sorterChange)="fotoKategorien.sorter$.next($event)"></pbc-sorter>
